<template>
  <Tabbar v-model="title" active-color="#06ccbf" inactive-color="#8e8e93" route safe-area-inset-bottom>
    <Tabbar-item name="appointment" replace :to="{ name: 'appointment' }">
      <img slot="icon" slot-scope="props" :src="props.active ? registrationSelect : registration" class="tabIcon" />
      <span class="tabTitle">{{ $t('appointment.visitors.registration') }}</span>
    </Tabbar-item>
    <Tabbar-item name="recordSearch" replace :to="{ name: 'recordSearch' }">
      <img slot="icon" slot-scope="props" :src="props.active ? recordSelect : record" class="tabIcon" />
      <span class="tabTitle">{{ $t('appointment.visitors.record') }}</span>
    </Tabbar-item>
  </Tabbar>
</template>

<script>
import { Tabbar, TabbarItem } from 'vant';
import record from '@/assets/icon/record.svg';
import recordSelect from '@/assets/icon/recordSelect.svg';
import registration from '@/assets/icon/registration.svg';
import registrationSelect from '@/assets/icon/registrationSelect.svg';
export default {
  components: { Tabbar, TabbarItem },
  data() {
    return {
      record,
      recordSelect,
      registration,
      registrationSelect,
      title: this.$route.name,
    };
  },
  computed: {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.tabIcon {
  width: 56px;
  height: 56px;
}

.tabTitle {
  font-size: 20px;
  letter-spacing: 0;
  text-align: center;
}
</style>
